import { IIepePortSettingsTemplateResponse } from '@kcftech/prometheus-client';
import { DataSourceTable } from 'components/data_source_table/DataSourceTable';
import { TableColumn } from 'components/data_table/types';
import { ActionMenuTableCell } from 'components/menu/ActionMenuTableCell';
import { TemplatesPagedDataSource } from 'custom_hooks/data_hooks/data_source/templatesDataSource';
import { DeleteTemplateCell } from 'pages/Settings/Templates/DeleteTemplateCell';
import { useMemo } from 'react';
import { getId } from 'utils/data';

export type TemplatesTableProps = Readonly<{
    dataSource: TemplatesPagedDataSource;
    locationId: string;
}>;

export default function TemplatesTable({ dataSource, locationId }: TemplatesTableProps) {
    const { reloadPage } = dataSource;

    const columns = useMemo<TableColumn<IIepePortSettingsTemplateResponse>[]>(
        () => [
            {
                id: 'TemplateName',
                header: () => 'Template Name',
                value: ({ rowData }) => rowData.Name,
            },
            {
                header: () => 'Actions',
                id: 'Actions',
                value: ({ rowData }) => (
                    <ActionMenuTableCell>
                        <DeleteTemplateCell
                            locationId={locationId}
                            rowData={rowData}
                            onChange={reloadPage}
                        />
                    </ActionMenuTableCell>
                ),
            },
        ],
        [locationId, reloadPage],
    );

    return (
        <DataSourceTable
            dataSource={dataSource}
            noResultMessage="There are no templates for this location."
            columns={columns}
            rowKey={getId}
        />
    );
}
